import { getAttribute, getUiState } from '../taxonomy';
import { getOversetAttributes } from '../product/taxonomy';
import { getCategoryError } from './details';
import { getSize } from '../iterable/getSize';

import { TAXONOMY_LIMITS } from '../../constants/validations';
import { ATTRIBUTE } from '../../constants/attributes';
import { VALUE } from '../../constants/product';
import { EMPTY } from '../../constants';
import { FORM } from '../../constants/forms';

export const errors = {
  invalidNumber(displayName) {
    return `${displayName} must be a valid number (e.g., 1, 1.5, 1 1/2)`;
  },
  noScale(displayName) {
    return `${displayName} must have a scale`;
  },
  overLimit(displayName) {
    return `${displayName} selected over limit`;
  },
  required(displayName) {
    return `${displayName} is required`;
  },
};

export function validateTaxonomyAttributes({ channel, product }) {
  const category = product.getIn([FORM.DETAILS, ATTRIBUTE.CATEGORY, VALUE]);

  if (getCategoryError({ category, channel })) return EMPTY.MAP;

  const { availableAttributes: attributes = [] } = getUiState({ channel, taxonomyId: category }, false);
  const taxonomyAttributes = product.getIn([FORM.DETAILS, ATTRIBUTE.TAXONOMY_ATTRIBUTES], EMPTY.MAP);
  const overset = getOversetAttributes(product.get(FORM.VARIATIONS));

  if (!getSize(attributes)) return EMPTY.MAP;

  function validateAttribute(result, attribute) {
    const { id: property, isMultivalued, required, variations } = attribute;

    const scale = taxonomyAttributes.getIn([property, 'scaleId']);
    const {
      displayName,
      availableOptions,
      availableScales,
      selectedOptions,
    } = getAttribute({ category, channel, property, scale });

    const defaultSelectionsCount = getSize(selectedOptions);
    const userSelectionsCount = getSize(taxonomyAttributes.getIn([property, 'values']));
    const size = isMultivalued
      ? defaultSelectionsCount + userSelectionsCount
      : defaultSelectionsCount || userSelectionsCount;

    if (!size && required && (!variations || !overset.has(property))) {
      return result.setIn([ATTRIBUTE.TAXONOMY_ATTRIBUTES, property], errors.required(displayName));
    }

    if (!isMultivalued && size > 1) {
      return result.setIn([ATTRIBUTE.TAXONOMY_ATTRIBUTES, property], errors.overLimit(displayName));
    }

    if (TAXONOMY_LIMITS.hasOwnProperty(property)) {
      const limit = TAXONOMY_LIMITS[property];
      const sizeForLimitCheck = isMultivalued ? userSelectionsCount : size;

      if (sizeForLimitCheck > limit) {
        return result.setIn([ATTRIBUTE.TAXONOMY_ATTRIBUTES, property], errors.overLimit(displayName));
      }
    }

    if (getSize(availableScales)) {
      if (
        !taxonomyAttributes.getIn([property, 'scaleId']) &&
        taxonomyAttributes.getIn([property, 'values', 0])
      ) {
        return result.setIn([ATTRIBUTE.TAXONOMY_ATTRIBUTES, property], errors.noScale(displayName));
      }

      if (
        !getSize(availableOptions) &&
        taxonomyAttributes.getIn([property, 'values', 0]) &&
        !/^(\d+(\.\d+)?|\.\d+|(\d+\s)?\d+\/\d+)$/.test(taxonomyAttributes.getIn([property, 'values', 0]))
      ) {
        return result.setIn([ATTRIBUTE.TAXONOMY_ATTRIBUTES, property], errors.invalidNumber(displayName));
      }
    }

    return result;
  }

  return attributes.reduce(validateAttribute, EMPTY.MAP);
}
